import { useState } from 'react';
import axios from 'axios';

interface DayEntryData {
  description: string;
  hours: number;
}

export const useCreateDayEntry = (date) => {
  const [dayEntry, setDayEntry] = useState();
  const [loadingDayEntry, setLoadingDayEntry] = useState<boolean>();

  const createDayEntry = async (
    dayEntryData: DayEntryData,
    assignmentId: string
  ) => {
    if (loadingDayEntry) return;
    try {
      setLoadingDayEntry(true);
      const { data } = await axios.post(`api/timetracking-day-entries/create`, {
        new_date: date,
        new_description: dayEntryData.description,
        new_actualhours: dayEntryData.hours,
        assignment: {
          new_axsassignmentid: assignmentId,
        },
      });
      data && setDayEntry(data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingDayEntry(false);
    }
  };

  return { dayEntry, loadingDayEntry, createDayEntry };
};
